import { useState, useEffect } from 'react';

/**
 * Chaves do localStorage para preferências de Usuários
 */
const STORAGE_KEYS = {
  VIEW_MODE: 'users_view_mode',
} as const;

/**
 * Interface de preferências de Usuários
 */
export interface UserPreferences {
  viewMode: 'grid' | 'table';
}

/**
 * Hook customizado para gerenciar preferências de Usuários com persistência em localStorage
 *
 * Salva e recupera automaticamente:
 * - Modo de visualização (grid/table)
 *
 * @example
 * ```tsx
 * const {
 *   viewMode,
 *   setViewMode
 * } = useUserPreferences();
 * ```
 */
export const useUserPreferences = () => {
  // Carregar preferências do localStorage na inicialização
  const [viewMode, setViewModeState] = useState<'grid' | 'table'>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEYS.VIEW_MODE);
      // Default: grid
      return (stored as 'grid' | 'table') || 'grid';
    } catch {
      return 'grid';
    }
  });

  // Salvar viewMode no localStorage sempre que mudar
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEYS.VIEW_MODE, viewMode);
    } catch (error) {
      console.error('Erro ao salvar viewMode no localStorage:', error);
    }
  }, [viewMode]);

  return {
    // Modo de visualização
    viewMode,
    setViewMode: setViewModeState,
  };
};
